<template>
  <v-dialog
    :value="value"
    @input="toggle"
    max-width="1200px"
    content-class="ArtzieModal"
    scrollable
  >
    <v-card>
      <v-card-title style="height: 50px; padding: 0">
        <v-spacer/>
        <tk-btn
          small
          icon
          @click="close"
        >
          <v-icon>fas fa-times</v-icon>
        </tk-btn>
      </v-card-title>
      <iframe
        frameborder="0"
        :src="`${url}?${locale}`"
        style="height: calc(100vh - 50px); width: 100%"
      ></iframe>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: ['value'],
  data () {
    return {
      bodyOriginalHeight: null,
      bodyOriginalOverflow: null,
      bodyOriginalScrollY: 0,
    }
  },

  computed: {
    locale () {
      if (this.$i18n.locale === 'en') return 'en'
      if (this.$i18n.locale === 'se') return 'sv'
      return undefined
    },
    url () {
      const url = process.env.VUE_APP_ARTZIE_URL
      const localePrefix = this.$i18n.locale === 'fi' ? 'www' : this.$i18n.locale
      return url.replace('{locale}', localePrefix)
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    },

    toggle (v) {
      this.$emit('input', v)
    }
  },

  watch: {
    async value (v) {
      if (v) {
        this.bodyOriginalHeight = document.body.style.height
        this.bodyOriginalOverflow = document.body.style.overflow
        this.bodyOriginalScrollY = window.scrollY
        document.body.style.height = '100vh'
        document.body.style.overflow = 'hidden'
        return
      }
      // document.body.style.height = this.bodyOriginalHeight
      // document.body.style.overflow = this.bodyOriginalOverflow
      document.body.removeAttribute('style');
      
      await this.$nextTick()
      window.scroll(0, this.bodyOriginalScrollY)
    }
  }
}
</script>

<style lang="scss">
.ArtzieModal {
  max-height: 100% !important;
}
</style>
